// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.good-tip-toast-wrapper {
    position: relative;
    transition: transform 400ms ease-in-out, opacity 400ms ease-in-out;
    border-radius: 0.35rem;
    overflow: hidden; 
}

.good-tip-toast-wrapper::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 4px; 
    width: var(--progress-width, 0%);
    background-color: #0d6efd;
    transition: width 0.05s linear;
    z-index: 10; 
}

.good-tip-toast-wrapper.hide {
    transform: translateX(120%);
    opacity: 0;
}

.good-tip-toast-wrapper.show {
    transform: translateX(0);
    opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/React/MainWindow/Content/Dashboard/GoodTipToast.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kEAAkE;IAClE,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,gCAAgC;IAChC,yBAAyB;IACzB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,UAAU;AACd","sourcesContent":[".good-tip-toast-wrapper {\n    position: relative;\n    transition: transform 400ms ease-in-out, opacity 400ms ease-in-out;\n    border-radius: 0.35rem;\n    overflow: hidden; \n}\n\n.good-tip-toast-wrapper::before {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    height: 4px; \n    width: var(--progress-width, 0%);\n    background-color: #0d6efd;\n    transition: width 0.05s linear;\n    z-index: 10; \n}\n\n.good-tip-toast-wrapper.hide {\n    transform: translateX(120%);\n    opacity: 0;\n}\n\n.good-tip-toast-wrapper.show {\n    transform: translateX(0);\n    opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
